// /**
//  * Layout component that queries for data
//  * with Gatsby's useStaticQuery component
//  *
//  * See: https://www.gatsbyjs.com/docs/use-static-query/
//  */

import * as React from "react"
import { useEffect, useState } from "react"
import "../../styles/main.css"
import "../../styles/fonts.css"
import PropTypes from "prop-types"
import Header from "../Globals/Header/Header"
import Footer from "../Globals/Footer/Footer"
import { get } from "../../helpers/utils"
import ScriptWrapper from "../Wrappers/ScriptWrapper/ScriptWrapper"
import { gTagScriptConsent, otGroupEvents } from "../Scripts/Gtm.Head";

const Layout = ({ children, seoData, globalComponents, language }) => {
  const FooterProps = globalComponents?.find(component => component?.Footer)
  const HeaderProps = globalComponents?.find(component => component?.Header)
  const footerCollection = get(
    FooterProps,
    "Footer.footerCollection.items",
    {}
  )?.find(item => item?.language === language) || {}

  const headerCollection = get(
    HeaderProps,
    "Header.headerCollection.items",
    {}
  )?.find(item => item?.language === language) || {}


  const [isLoaded, setIsLoaded] = useState(false);
  const isProduction = process.env.NODE_ENV === 'production';

  // Prevent FOUC (Flash of Unstyled Content) by adding loaded class when component mounts
  useEffect(() => {
    setIsLoaded(true);
    document.documentElement.classList.add('loaded');
  }, []);
  return (
    <>
      <ScriptWrapper seoHead={seoData} />
      <div media="print" className="main-container overflow-x-hidden">
        <Header {...headerCollection} language={language} />
        <div className={`content-container w-full bg-white`}>
          <main>{children}</main>
        </div>
        <Footer {...footerCollection} />
      </div>
      {isLoaded && <script
        async
        type="text/javascript"
        dangerouslySetInnerHTML={{ __html: gTagScriptConsent }}
      />}
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  seoData: PropTypes.object,
  globalComponents: PropTypes.array,
  language: PropTypes.string,
  languageSelection: PropTypes.shape({
    languages: PropTypes.array,
    defaultLanguage: PropTypes.object
  }),
}

export default Layout
